var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-primary",class:`col-6 col-sm-6 col-md-${_vm.col} col-lg-${_vm.col} col-xl-${_vm.col}`},[_c('div',{staticClass:"card card-with-shadow border-0 p-primary dashboard-widgets h-100"},[_c('div',{staticClass:"widget-data"},[_c('h6',[_vm._v(_vm._s(_vm.count))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }